<template>
  
    <div class="card card-height" :class="$attrs.class">
      <div class="card-body">
          <h5 class="font-weight-bolder">Tokens</h5>
      <div class="row table-responsive">
        <table id="datatable-basic" class="table table-flush">
          <tbody>
            <tr v-for="item in client.token" :key="item" :value="item">
              <td>{{item}}</td>
              <td>
                <a id="info"  class="mx-3"  style="cursor:pointer" data-bs-toggle="tooltip" data-bs-placement="top" :title="title" @click="copy(item)" @mouseout="title='Copiar'">
                  <i class="fa fa-clipboard" aria-hidden="true" ></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>


</template>
<script>
export default {
  name: "TokenTable",
  components: {},
  props: {
    client: {
      type: Object,
      default: () => null
    },
  },
data() {
  return {
    title: 'Copiar',
  }
},
mounted() {
  },
  methods: {
    copy(token) {
      navigator.clipboard.writeText(token);
      this.title= 'Copiado!';
    },
  },
};
</script>
<style scoped>
.table-responsive {
  padding: 1rem;
  max-height: 8.9rem;
  height: 8.9rem;
}

</style>
